import ArrowBack from "arrow-back-double.svg";
import ForwardingOrder from "components/shared/forwarding/order";
import ForwardingOrderInfo from "components/shared/forwardingOrderInfo";
import moment from "moment";
import Tooltip from "rc-tooltip";
import React from "react";
import { applyForwardingOrder, deleteForwardingOrder } from "sources/books/bids/closeBids";

export default function RequireForwardingOrderBtn(props) {
    const { forwardingOrder, profile, modal, refreshBid, bidId } = props;

    const saveData = (newData) => {
        if (newData) {
            const formatted = { ...newData };
            formatted.fromPointPlanEnterTime = moment(formatted.fromPointPlanEnterTime).format("YYYY-MM-DDTHH:mm");
            return applyForwardingOrder({ bidId, ...formatted }).then(() => {
                refreshBid();
                return Promise.resolve(true);
            });
        } else {
            return deleteForwardingOrder({ bidId }).then(() => {
                refreshBid();
                return Promise.resolve(true);
            });
        }
    };

    const showModal = () => {
        modal({
            name: "default",
            windowMod: "wide",
            title: (
                <>
                    Запросить обратный рейс&nbsp;
                    <ForwardingOrderInfo />
                </>
            ),
            CustomBody: ForwardingOrder,
            bodyData: { forwardingOrder, saveData, profile },
        });
    };

    return (
        <div className="map-bid-legend">
            <Tooltip overlay={ForwardingOrderInfo.overlay} placement="right">
                <div
                    className="map-bid-legend__button map-bid-legend__button--require-forwarding-order"
                    onClick={showModal}
                >
                    <ArrowBack />
                </div>
            </Tooltip>
        </div>
    );
}
